<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text(v-if="product") {{ $t('edit') }} Product
              p.mb-0.h6.basic800--text(v-else) {{ $t('add') }} Product

        v-card-text.pa-0
          v-form(ref="form")
            div.pa-4(style="overflow-x: hidden;")

              .product-name
                .label.basic600--text.text-uppercase.mb-1 {{ $t('product_name.label') }}*
                v-text-field.mt-2(v-model='name' :placeholder="$t('product_name.placeholder')" background-color="basic200" outlined dense height="40" persistent-hint :rules="rules.not_empty" counter :maxlength="145")

              .product-price
                .label.basic600--text.text-uppercase.mb-1 {{ $t('price.label') }}*
                v-text-field.mt-2(v-model='price' :placeholder="$t('price.placeholder')" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol")

              .description
                .label.basic600--text.text-uppercase.mb-1 {{ $t('description.label') }}
                v-textarea.mt-2(v-model='description' :placeholder="$t('description.placeholder')" outlined dense persistent-hint counter background-color="basic200")

              div.show-description.d-flex
                y-checkbox.my-auto.mx-0.pa-0(v-model="showDescription" hide-details :disabled="!description")
                  template(v-slot:label)
                    div.p1.my-auto Show description in invoice

              v-row
                v-divider.basic300.my-5

              div.show-description.d-flex
                y-checkbox.my-auto.mx-0.pa-0(v-model="unlisted" hide-details)
                  template(v-slot:label)
                    div.my-auto
                      .p1.textColorDefault--text One-time product
                      .c1.basic600--text This product will not be saved in product manager.
              
              v-row
                v-divider.basic300.my-5

              v-layout
                v-spacer
                .mb-1.label.basic600--text.text-uppercase Select quantity
                v-spacer
              v-layout
                v-spacer
                v-btn.my-auto(icon small @click="quantity--" :disabled="quantity < 1")
                  eva-icon.mt-1(name="minus-circle-outline" height="24" width="24" :fill="quantity < 1 ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
                v-layout.divbox.subtitle-1.my-auto.text-center.mx-1(style="width: 100%") 
                  .s1.ma-auto {{ quantity }}
                v-btn.my-auto(icon small @click="quantity++")
                  eva-icon.mt-1(name="plus-circle-outline" height="24" width="24" :fill="$vuetify.theme.themes[$theme].primary500")
                v-spacer

              v-layout.my-6(v-if="hasDiscountPermission")
                v-spacer
                .discount(v-if="discount")
                  v-layout
                    .s2.primary400--text(v-if="discount.isPercentage") Discount: {{ discount.value }}%
                    .s2.primary400--text(v-else) Discount: {{ discount.value | displayPrice }}
                    eva-icon.mt-1.ml-2(name="trash-outline" height="16" width="16" :fill="$vuetify.theme.themes[$theme].danger500" @click="discount = null")
                .button-Aa-medium.info500--text(v-else @click="openEditDiscount = true") Add discount
                v-spacer

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text Cancel
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading" dark)
            .button-AA-medium.basic100--text {{ $t('save') }}

    .modals
      AddDiscount(v-if="openEditDiscount" :open.sync="openEditDiscount" :initialDiscount.sync="discount" @added="handleAddDiscount")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddDiscount from '@/components/forms/AddDiscount.vue'

export default {
  name: 'AddProductDialog',
  props: ['open', 'parentProduct', 'hasDiscountPermission'],
  components: { AddDiscount },
  data: () => ({
    name: null,
    price: null,
    description: null,
    discount: null,
    isLoading: false,
    showDescription: false,
    openEditDiscount: false,
    unlisted: true,
    quantity: 1,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      number_not_empty: [v => v !== null || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    product: {
      get() {
        return this.parentProduct
      },
      set(newValue) {
        this.$emit('update:parentProduct', newValue)
      }
    },
    authMember () {
      return this.$store.state.user.member
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.product) {
      if (this.product.image) {
        this.resizeImageFileUrl = this.product.image.file
      }
      this.name = this.product.name
      this.price = this.product.price/this.$currency.multiplier
      this.description = this.product.description
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleAddDiscount (val) {
      this.discount = val
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var memberIds = [this.authMember.id]
      this.loadSaveProduct = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('name', this.name)
      params.set('price', (parseFloat(this.price)).toFixed(this.$currency.exponent).replace('.', ''))
      params.set('description', this.description || '')
      params.set('unlisted', this.unlisted)
      memberIds.forEach(mid => {
        params.set('members', mid)
      })
      if (this.showDescription && this.description) {
        params.set('description_visibility', ["invoice"])
      }
      if (this.product) {
        this.axios.put(`/products/${this.product.id}/`, params)
          .then(resp => {
            this.showMessage(['success', this.$t('success_message.product_edited')])
            this.product = resp.data
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          return
      }
      this.axios.post(`/products/`, params)
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.product_added')])
          const newProduct = {
            quantity: this.quantity,
            product: resp.data,
            discount: this.discount ? this.discount.value : 0
            ,
            show_discount_as_percentage: this.discount ? this.discount.isPercentage : false
          }
          this.$emit('added', newProduct)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.divbox {
  border: 2px solid var(--v-basic400);
  background-color: var(--v-basic200);
  height: 40px;
  max-width: 60px;
  border-radius: 5px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "product_image": "Product Image",
    "upload": "Upload",
    "edit": "Edit",
    "details": "Details",
    "product_name": {
      "label": "Name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "slash_price": {
      "label": "Price before Discount",
      "placeholder": "0"
    },
    "weight": {
      "label": "Weight",
      "placeholder": "Max weight = 60 kg"
    },
    "description": {
      "label": "Description",
      "placeholder": "Write product description here"
    },
    "has_inventory": "Has Inventory",
    "no_inventory": "No Inventory",
    "quantity": {
      "label": "In Stock",
      "placeholder": "How many stock left"
    },
    "whos_selling": "Who's Selling",
    "add": "Add",
    "save": "Save",
    "meta_title": "Meta Title (SEO)",
    "meta_description": "Meta Description (SEO)",
    "meta_keywords_note": "Note: Meta keywords is not supported.",
    "meta_keywords_ref": "More info here."
  }
}
</i18n>
